<template>
  <div class="content-body">
    <div class="container-fluid">
      <Breadcrumb name="Send Money" :breadcrumb="breadcrumb"/>
      <!-- row -->
      <div class="row">
        <div :class="userGeneralInfoData ? 'col-xl-8 col-xxl-8' : 'col-xl-12 col-xxl-12'">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Send Money</h4>
              <div v-show="!userGeneralInfoData && accountExistMsg != ''" class="alert alert-success alert-dismissible fade show">
                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="mr-2"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>
                <strong>{{accountExistMsg}}</strong>
              </div>
            </div>
            <div class="card-body">
              <div class="basic-form">
                <Form @submit="sendCall"
                      :initial-values="{deductChargesFromTransactionAmount: 0,emailOrPhone : emailOrPhone,amount : amount}">
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Email Address or Phone</label>
                    <div class="col-sm-9">
                      <Field
                          class="form-control"
                          type="text"
                          name="emailOrPhone"
                          rules="required"
                          disabled
                      />
                      <ErrorMessage name="emailOrPhone"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Amount</label>
                    <div class="col-sm-9">
                      <Field
                          class="form-control"
                          type="text"
                          name="amount"
                          rules="required|numeric"
                          disabled
                      />
                      <ErrorMessage name="amount"/>
                    </div>
                  </div>
<!--                  <div class="form-group row">-->
<!--                    <label class="col-sm-3 col-form-label">Wallet</label>-->
<!--                    <div class="col-sm-9">-->
<!--                      <select class="form-control" v-model="selectedValet">-->
<!--                        <option :key="valetIndex" :value="valet.id" v-for="(valet, valetIndex) in valetData">-->
<!--                          {{ valet.currency.code }}-->
<!--                        </option>-->
<!--                      </select>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Wallet</label>
                    <div class="col-sm-9">
                      <select class="form-control" v-model="selectedValet" disabled>
                        <option :value="$store.getters.getUserRequestSendMoneyData.user_account.currency.id" >
                          {{ $store.getters.getUserRequestSendMoneyData.user_account.currency.code }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-3"></div>
                    <div class="col-sm-9">
                      <div class="form-check">
                        <Field name="deductChargesFromTransactionAmount" type="checkbox" :value="1"
                               class="form-check-input"/>
                        <label class="form-check-label">Deduct charges from transaction amount</label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-10">
                      <Button class="btn btn-primary" :loading="loader">Send</Button>
                      <Button class="btn btn-dark ml-1" type="button" @click="$router.push({name:'request-money'})">Back</Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-14 col-sm-4" v-if="userGeneralInfoData">
          <div class="card overflow-hidden">
            <div class="text-center p-3 overlay-box " style="background-image: url(images/big/img1.jpg);">
              <div class="profile-photo">
                <img                        :src="userGeneralInfoData.avatar? userGeneralInfoData.avatar : `${publicPath}dist/img/avatar-user.png`" width="100" class="img-fluid rounded-circle" alt="">
              </div>
              <h3 class="mt-3 mb-1 text-white">{{userGeneralInfoData.first_name+' '+userGeneralInfoData.last_name}}</h3>
              <p class="text-white mb-0">User</p>
            </div>
            <ul class="list-group list-group-flush">
              <li class="list-group-item d-flex justify-content-between"><span class="mb-0">Contact</span> <strong class="text-muted">{{userGeneralInfoData.phone_number}}</strong></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    let userRequestData = this.$store.getters.getUserRequestSendMoneyData
    this.emailOrPhone = userRequestData.user_account.user.email
    this.amount = userRequestData.amount / 100
    this.selectedValet = this.$store.getters.getUserRequestSendMoneyData.user_account.currency.id
    // setTimeout(() => {
    //   this.getValetData()
    // }, 1000);

  },
  data() {
    return {
      loader: false,
      emailOrPhone: '',
      amount: '',
      selectedValet: null,
      userGeneralInfoData: null,
      valetData: [],
      breadcrumb: [
        {name: 'App'},
        {name: 'User Request'},
        {name: 'Send Money'},
        {name: 'Initiate'},
      ],
      accountExistMsg: ''

    }
  },
  methods: {
    sendCall(values) {
      if (typeof (values.deductChargesFromTransactionAmount) == 'undefined') {
        values.deductChargesFromTransactionAmount = 0;
      }
      values.payerAccountId = this.selectedValet;
      values.amount = values.amount * 100
      let data = values
      this.loader = true
      this.makeRequest('post', 'v1/initiate-send-money', data, {}, false).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.$store.commit("setUserRequestSendMoneyHash", callResponse.response.data.data.hash)
            this.$router.push({name: 'user-request-send-money-confirm', params: {emailOrPhone: this.emailOrPhone}})
          } else if (code == 401) {
            this.$router.push({name: 'send-otp'});
          }
        }

      });

    },
    getValetData() {
      this.makeRequest('post', 'v1/get-wallet-list', {}, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          let responseData = callResponse.response.data.data
          if (code == 200) {
            this.valetData = responseData
            this.setSelectValetValue()
          }
        }

      });
    },
    setSelectValetValue() {
      this.valetData.forEach((obj) => {
        if (obj.is_default == 1) {
          this.selectedValet = obj.id
        }
      })

    }
  },
}
</script>

